import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from "../../common/with-router";
import { Card, Form, Button, Row, Col, Table } from "react-bootstrap";
import { FaSearch, FaEraser, FaRegEdit } from "react-icons/fa";
import AsyncSelect from "react-select/async";
import moment from "moment";
import api from "../../services/api";
import Swal from 'sweetalert2';
import { hasPerm, formataDataHoraExibicao, getCurrentUser, formataDataExibicao } from "../../common/utils";

class DespesasRelatorio extends Component {
    state = {
        loading: false,
        error: "",
        listRegistros: [],
        totalPeriodo: 0,

        filtro_data_inicio: "",
        filtro_data_fim: "",
        filtro_programa_id: "",
        filtro_programa_nome: "",
        filtro_prestador_id: "",
        filtro_prestador_nome: "",

        programa_select_key: 0,
        prestador_select_key: 0,
    };

    componentDidMount() {
        const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
        const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

        const dados_usuario = getCurrentUser() || {};
        const programa_id = dados_usuario.ambiente_programa_id || "";

        this.setState({
            filtro_data_inicio: startOfMonth,
            filtro_data_fim: endOfMonth,
            filtro_programa_id: programa_id,
        },
        () => {
            if (this.temObrigatorios()) this.consultaRegistro();
        }
        );
    }

    temObrigatorios = () => {
        const { filtro_programa_id, filtro_data_inicio, filtro_data_fim } = this.state;
        return Boolean(filtro_programa_id && filtro_data_inicio && filtro_data_fim);
    };

    handleChangeFiltros = (event, fieldName) => {
        if (fieldName === "programa_id") {
            this.setState((prev) => ({
                filtro_programa_id: event?.value || "",
                filtro_programa_nome: event?.label || "",
                filtro_prestador_id: "",
                filtro_prestador_nome: "",
                prestador_select_key: prev.prestador_select_key + 1,
            }));
            return;
        }

        if (fieldName === "prestador_id") {
            this.setState({
                filtro_prestador_id: event?.value || "",
                filtro_prestador_nome: event?.label || "",
            });
            return;
        }

        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    limparFiltros = () => {
        const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
        const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
        const { ambiente_programa_id } = getCurrentUser() || {};

        this.setState(
        {
            filtro_data_inicio: startOfMonth,
            filtro_data_fim: endOfMonth,
            filtro_programa_id: ambiente_programa_id || "",
            filtro_programa_nome: "",
            filtro_prestador_id: "",
            filtro_prestador_nome: "",
            error: "",
        },
        () => {
            if (this.temObrigatorios()) this.consultaRegistro();
        }
        );
    };

    carregaProgramas = async (inputValue) => {
        try {
            const { data } = await api.get(`/programas/?nome=${inputValue || ""}`);
            return (data?.results || []).map((programa) => ({ 
                value: programa.id, 
                label: programa.nome 
            }));
        } catch {
            return [];
        }
    };

    carregaPrestadores = async (inputValue) => {
        const dados_usuario = getCurrentUser();
        const { filtro_programa_id } = this.state;

        const filtro_programa = filtro_programa_id || dados_usuario?.ambiente_programa_id;

        if (!filtro_programa) return [];
        try {
            const { data } = await api.get(`/pessoas/prestadores/?programa_id=${filtro_programa}&nome=${inputValue || ""}`);
            return (data?.results || []).map((prestador) => ({ 
                value: prestador.id, 
                label: prestador.nome 
            }));
        } catch {
            return [];
        }
    };

    filtrar = (e) => {
        e.preventDefault();

        if (!this.temObrigatorios()) {
            this.setState({ 
                error: "Informe Programa, Data início e Data fim para consultar." 
        }); 
        return;}

        this.consultaRegistro();
    };

    consultaRegistro() {
    if (!this.temObrigatorios()) {
        this.setState({ error: "Informe Programa, Data início e Data fim para consultar." });
        return;
    }

    this.setState({ loading: true, error: "" });

    let filtros = '?1=1';

    if (this.state.filtro_data_inicio) {
        filtros += '&data_inicio=' + encodeURIComponent(this.state.filtro_data_inicio);
    }

    if (this.state.filtro_data_fim) {
        filtros += '&data_fim=' + encodeURIComponent(this.state.filtro_data_fim);
    }

    if (this.state.filtro_programa_id) {
        filtros += '&programa_id=' + encodeURIComponent(this.state.filtro_programa_id);
    }

    if (this.state.filtro_prestador_id) {
        filtros += '&prestador_id=' + encodeURIComponent(this.state.filtro_prestador_id);
    }

    api.get('/agendamentos/despesas/relatorio/' + filtros)
        .then(response => {
        let dados = Array.isArray(response.data)
            ? response.data
            : (Array.isArray(response.data?.results) ? response.data.results : []);

        // total
        let total = 0;
        dados.forEach(item => {
            const v = parseFloat(item?.valor);
            if (!isNaN(v)) total += v;
        });

        this.setState({
            loading: false,
            error: "",
            listRegistros: dados,   
            totalPeriodo: total
        });
        })
        .catch(error => {
        let erro_msg = 'Erro ao consultar o relatório, tente novamente.';

        if (error?.response?.status === 500) {
            erro_msg = 'Servidor indisponível no momento';
        } else if (error?.response?.status === 403) {
            erro_msg = 'Você não tem permissão para acessar essa área';
        }

        this.setState({
            loading: false,
            error: erro_msg,
            listRegistros: [],
            totalPeriodo: 0
        });
        });
    }

    exportarCSV = () => {
        const { listRegistros } = this.state;

       if (!Array.isArray(listRegistros) || listRegistros.length === 0) {
            Swal.fire({
                icon: 'info',
                title: 'Atenção',
                text: 'Não há dados para exportar',
                confirmButtonText: 'OK'
            });
            return;
        }

        const headers = [
            "ID",
            "Descrição",
            "Data",
            "Categoria",
            "Paciente",
            "Prestador",
            "Cidade",
            "UF",
            "Valor",
        ];

        const csvData = listRegistros.map((item) => {
            const categoria =
            item?.categoria_outros ||
            item?.dados_categoria?.titulo ||
            (item?.despesa_categoria_id ? `ID ${item.despesa_categoria_id}` : "");

            return [
            item.id || "",
            (item.descricao || "").toString().replace(/\r?\n|\r/g, " ").trim(),
            item.data ? formataDataExibicao(item.data) : "",
            categoria || "",
            item?.dados_paciente?.nome || "",
            item?.dados_prestador?.nome || "",
            item?.dados_local?.cidade || "",
            item?.dados_local?.uf || "",
            (parseFloat(item?.valor) || 0).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            }),
            ];
        });

        const csvContent = [headers, ...csvData]
            .map((row) => row.map((field) => `"${String(field).replace(/"/g, '""')}"`).join(","))
            .join("\n");

        const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `despesas_${new Date().toISOString().split("T")[0]}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    renderRows = () => {
        const { listRegistros } = this.state;
        if (!listRegistros.length) {
            return (
                <tr><td colSpan={9}>Nenhum registro encontrado</td></tr>
            );
        }

        return listRegistros.map((item, idx) => {
        const categoria = item?.categoria_outros || item?.dados_categoria?.titulo || (item?.despesa_categoria_id ? `ID ${item.despesa_categoria_id}` : "");

        return (
            <tr key={idx}>
                <td>{item.id}</td>
                <td>{item.descricao || "-"}</td>
                <td>{formataDataExibicao(item.data || "")}</td>
                <td>{categoria || "-"}</td>
                <td>{item?.dados_paciente?.nome || "-"}</td>
                <td>{item?.dados_prestador?.nome || "-"}</td>
                <td>{item?.dados_local?.cidade || "-"}</td>
                <td>{item?.dados_local?.uf || "-"}</td>
                <td>{(parseFloat(item?.valor) || 0).toLocaleString("pt-BR", {style: "currency",currency: "BRL",})}</td>
            </tr>
        );
        });
    };

    render() {
        if (!hasPerm("view_agendamentos")) return <Navigate to="/sem-permissao" />;

        const dados_usuario = getCurrentUser() || {};
        const botaoFiltrarDesabilitado = !this.temObrigatorios();

        return (
        <div>
            <Row className="align-items-center">
            <Col sm={6} lg={6}>
                <h4 className="page-title">Relatório de Despesas</h4>
            </Col>
            </Row>

            <Card className="cardDestaque">
                <Card.Body>
                    <h4>Filtros</h4>

                    {this.state.error && <div className="alert alert-warning py-2">{this.state.error}</div>}

                    <Form onSubmit={this.filtrar}>
                        <Row>
                            {!dados_usuario.ambiente_programa_id && (
                            <Col sm={4} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Programa <span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            key={this.state.programa_select_key}
                                            cacheOptions
                                            defaultOptions
                                            name="programa_id"
                                            placeholder="Buscar programa..."
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            loadOptions={this.carregaProgramas}
                                            onChange={(e) => this.handleChangeFiltros(e, "programa_id")}
                                            value={this.state.filtro_programa_id ? {value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome || "",} : null}
                                        />
                                </Form.Group>
                            </Col>
                            )}

                            <Col sm={2} xs={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data Início <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_inicio"
                                            value={this.state.filtro_data_inicio}
                                            onChange={(e) => this.handleChangeFiltros(e, "filtro_data_inicio")}
                                        />
                                </Form.Group>
                            </Col>

                            <Col sm={2} xs={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data Fim <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_fim"
                                            value={this.state.filtro_data_fim}
                                            onChange={(e) => this.handleChangeFiltros(e, "filtro_data_fim")}
                                        />
                                </Form.Group>
                            </Col>

                            <Col sm={4} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Prestador</Form.Label>
                                    <AsyncSelect
                                        key={this.state.prestador_select_key}
                                        cacheOptions
                                        defaultOptions
                                        name="prestador_id"
                                        placeholder="Selecionar prestador..."
                                        noOptionsMessage={() => "Nenhum resultado encontrado"}
                                        loadOptions={this.carregaPrestadores}
                                        onChange={(e) => this.handleChangeFiltros(e, "prestador_id")}
                                        value={this.state.filtro_prestador_id ? {value: this.state.filtro_prestador_id,label: this.state.filtro_prestador_nome || "",} : null}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
                            <Button type="submit" variant="secondary" size="sm" disabled={botaoFiltrarDesabilitado}>
                                <FaSearch /> Filtrar
                            </Button>

                            <Button type="button" size="sm" variant="light" className="ms-2" onClick={this.limparFiltros}>
                                <FaEraser /> Limpar filtro
                            </Button>

                            <div className="ms-auto">
                                {(dados_usuario["tipo_usuario"] === "" || dados_usuario["tipo_usuario"] === "gestor") && (
                                    <Button type="button" variant="success" size="sm" onClick={() => this.exportarCSV()}>
                                        <FaRegEdit /> Exportar CSV
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Form>

                    <Table responsive className="custom-table mt-3">
                        <thead>
                            <tr>
                            <th>ID</th>
                            <th>Descrição</th>
                            <th>Data</th>
                            <th>Categoria</th>
                            <th>Paciente</th>
                            <th>Prestador</th>
                            <th>Cidade</th>
                            <th>Estado</th>
                            <th>Valor</th>
                            </tr>
                        </thead>

                        <tbody>
                            {this.state.loading ? (
                                <tr><td colSpan={9}>Carregando...</td></tr>
                                    ) : this.state.error ? (
                                <tr><td colSpan={9}>{this.state.error}</td></tr>
                                ) : ( this.renderRows()
                            )}
                            <tr className="table-secondary">
                                <td colSpan={8} align="right"><strong>Total:</strong></td>
                                <td><strong>{(this.state.totalPeriodo || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL",})}</strong></td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </div>
        );
    }
}

export default withRouter(DespesasRelatorio);